// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ffDqIkAGHUQIirGUrcqd{grid-template-columns:repeat(2,1fr);gap:12px;display:grid}.TyMsqHCJz45EJqyhRHSa{gap:8px;padding:24px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardsContainer": `ffDqIkAGHUQIirGUrcqd`,
	"choiceTile": `TyMsqHCJz45EJqyhRHSa`
};
export default ___CSS_LOADER_EXPORT___;
